import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { get, groupBy, map } from 'lodash';

const useStyles = makeStyles()({
  root: {
    marginTop: 20,
    minWidth: 300,
  },
  table: {},
});

export default function BasicTable({ shipments, clientOption }) {
  const { classes } = useStyles();
  const groupList = groupBy(shipments, 'client_id');
  const newList = map(groupList, (value, key) => {
    const name = get(
      clientOption.find((c) => c.value === key),
      'text',
    );
    return {
      name,
      number: value.length,
    };
  });
  return (
    <TableContainer component={Paper} className={classes.root}>
      <div style={{ marginLeft: 5 }}>
        Total shipments: <b>{shipments.length}</b>
      </div>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Client</TableCell>
            <TableCell>Shipment</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {newList &&
            newList.map((row) => (
              <TableRow key={row.name}>
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell>{row.number}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
